import { render } from "./SshQuickCommands.vue?vue&type=template&id=4d95562b&scoped=true"
import script from "./SshQuickCommands.vue?vue&type=script&lang=js"
export * from "./SshQuickCommands.vue?vue&type=script&lang=js"

import "./SshQuickCommands.vue?vue&type=style&index=0&id=4d95562b&scoped=true&lang=css"
/* custom blocks */
import block0 from "./SshQuickCommands.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/Users/shaohuanqing/dev/kuboard-spray/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d95562b"]])

export default __exports__